import { api } from '@marketplace-web/core-api/core-api-client-util'

import { FeedbackRatingOptionsResp } from '../types/feedback-rating'

export const getConversationFeedbackRatingOptions = (
  userId: number,
  conversationId: number | string,
) =>
  api.get<FeedbackRatingOptionsResp>(
    `/users/${userId}/msg_threads/${conversationId}/feedback_ratings`,
  )
